import React from "react";
import { divIcon } from "leaflet";
import { renderToString } from "react-dom/server";

export const getMapPin = ({ text, textColor, pinColor }) => {
    // return <MapPin {...style} />
    return divIcon({
        html: renderToString(<svg width="37" height="45" viewBox="0 0 26 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 0C6.0974 0 0.481453 5.83195 0.481453 13C0.481453 15.1519 0.999529 17.2855 1.98441 19.1779L12.3154 33.5811C12.4529 33.8397 12.715 34 13 34C13.285 34 13.547 33.8397 13.6846 33.5811L24.0194 19.1715C25.0005 17.2855 25.5185 15.1518 25.5185 12.9999C25.5185 5.83195 19.9026 0 13 0Z"
                fill={pinColor} />
            <text x="30%" y="50%" fontFamily="Verdana" fontSize="10" fill={textColor}>{text}</text>
        </svg>),
        className: 'border-none background-transparent'
    });
};